import * as TYPES from './Proximity.types';

export const NO_PROXIMITY = 'no_proximity';

const initialState = {
  activeLayer: NO_PROXIMITY,
  layerConfigs: {
    near_school: {
      range: '1000',
      place: 'near_school',
    },
    near_retailer: {
      range: '1000',
    },
  },
  lastApplied: null,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.SET_PROXIMITY_SELECTION:
      return { ...state, ...(action.payload || {}) };

    case TYPES.UPDATE_PROXIMITY_SELECTION:
      return { ...state, ...action.payload };

    case TYPES.RESET_PROXIMITY_SELECTION:
      return initialState;

    case TYPES.SET_LAST_APPLIED_PROXIMITY:
      return { ...state, lastApplied: action.payload };

    default:
      return state;
  }
};

export default reducer;
